import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=1939b9a3&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=js&"
export * from "./Default.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/layouts/default.scss?vue&type=style&index=0&id=1939b9a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1939b9a3",
  null
  
)

export default component.exports